module.exports = __webpack_public_path__ + "pos-venda.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images2/icons/pos-venda.png
 ** module id = 756
 ** module chunks = 0
 **/